import React from 'react';
import { AccordionBodyItemView } from 'component/Accordion';
import { isLegacyClosestSettlementView } from 'utils/HaReportFormVersion';

export const ClosestSettlementView = (props) => {
  const {
    formData,
    translatedFormData,
    translateState,
  } = props;

  const nearest = formData.info.location?.nearest_settlement_name ?? {};
  const useLegacyView = isLegacyClosestSettlementView(formData);

  if (nearest.matches) {
    return (
      <AccordionBodyItemView
        accordionSubId="2.6"
        titleUA="Найближчий населений пункт"
        titleEN="Closest settlement"
        children={<div>Співпадає з 2.5 \ Matches 2.5</div>}
      />
    );
  }

  if (useLegacyView) {
    return (
      <AccordionBodyItemView
        accordionSubId="2.6"
        titleUA="Найближчий населений пункт"
        titleEN="Closest settlement"
        children={(
          <div>
            <div>
              Не співпадає з 2.5 (вказати нижче ТГ, населений пункт) \
              Doesn’t match 2.5 (specify below council, settlement)
            </div>
            {nearest.settlement_name && (
              <div>
                {translateState && translatedFormData?.nearest_settlement_name}
                {!translateState && nearest.settlement_name}
              </div>
            )}
          </div>
        )}
      />
    );
  }

  return (
    <AccordionBodyItemView
      accordionSubId="2.6"
      titleUA="Найближчий населений пункт"
      titleEN="Closest settlement"
      children={(
        <div className="flex-column-group">
          <div>
            Не співпадає з 2.5 (вказати нижче ТГ, населений пункт) \
            Doesn’t match 2.5 (specify below council, settlement)
          </div>
          {nearest.local_community && (
            <div>
              <div>Територіальна громада / Local community</div>
              <div>{nearest.local_community}</div>
            </div>
          )}
          {nearest.settlement_name && (
            <div>
              <div>Населений пункт / Locality</div>
              <div>
                {translateState && translatedFormData?.nearest_settlement_name}
                {!translateState && nearest.settlement_name}
              </div>
            </div>
          )}
          {nearest.settlement_code && (
            <div>
              <div>Код нас. пункту / Settlement ID</div>
              <div>{nearest.settlement_code}</div>
            </div>
          )}
        </div>
      )}
    />
  );
};
